import { signOut } from 'firebase/auth';
import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link } from 'react-router-dom';
import auth from '../../firebase.init';
import './Header.css';

const Header = () => {

    const [user, loading, error] = useAuthState(auth);
    const handleSignOut=()=>{
        signOut(auth);
    }
    return (
        <div>
             <nav className="navbar navbar-expand-lg navbar-light bg-primary">
  <div className="container-fluid ps-5 pe-5">
    
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav">
        <li className="nav-item">
          <Link className="nav-link text-light" aria-current="page" to="/home">Home</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link text-light" aria-current="page" to="/services">Services</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link text-light" to="/blog">Blog</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link text-light" to="/about">About</Link>
        </li>
        <li className="nav-item">
            
             { 
             user?<p className="nav-link text-light sign-out" onClick={handleSignOut}>Signout</p>:<Link className="nav-link text-light" to="/login">Login</Link>
             }
            
          
        </li>
       
      </ul>
    </div>
  </div>
</nav>
        </div>
    );
};

export default Header; 